<div *ngIf="form" [formGroup]="form" bindQueryParams>
    <div class="row">
        <mat-form-field>
            <mat-label>Numero Incarico</mat-label>
            <buffered-input #focusMePls matInput formControlName="numero"></buffered-input>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Stato Incarico</mat-label>
            <stato-incarico-picker [fromSearch]="true" formControlName="stato"></stato-incarico-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Data Incarico</mat-label>
            <date-range-picker formControlName="data"></date-range-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Numero Sinistro</mat-label>
            <buffered-input formControlName="numero_sinistro"></buffered-input>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Data Sinistro</mat-label>
            <date-range-picker formControlName="data_sinistro"></date-range-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Data Sopralluogo</mat-label>
            <date-range-picker formControlName="data_sopralluogo"></date-range-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Data Spedizione</mat-label>
            <date-range-picker formControlName="data_spedizione"></date-range-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Data Scadenza</mat-label>
            <date-range-picker formControlName="data_scadenza"></date-range-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Incaricato</mat-label>
            <user-picker [defaultSearch]="{studio:form?.value?.studio}" formControlName="incaricato"></user-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Inseritore</mat-label>
            <user-picker [defaultSearch]="{studio:form?.value?.studio}" formControlName="inseritore"></user-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Accertatore</mat-label>
            <user-picker [defaultSearch]="{studio:form?.value?.studio}" formControlName="accertatore"></user-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Auditor</mat-label>
            <user-picker [defaultSearch]="{studio:form?.value?.studio}" formControlName="auditor"></user-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Firmatario</mat-label>
            <user-picker [defaultSearch]="{studio:form?.value?.studio}" formControlName="firmatario"></user-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Evasore</mat-label>
            <user-picker [defaultSearch]="{studio:form?.value?.studio}" formControlName="evasore"></user-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Liquidatore</mat-label>
            <liquidatore-picker formControlName="liquidatore"></liquidatore-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Tipo di Danno</mat-label>
            <tipo-danno-picker formControlName="tipo_danno"></tipo-danno-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Studio Associato</mat-label>
            <studio-picker formControlName="studio"></studio-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Filiale</mat-label>
            <filiale-picker formControlName="filiale"></filiale-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Polizza</mat-label>
            <polizza-picker formControlName="polizza"></polizza-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Agenzia</mat-label>
            <agenzia-picker formControlName="agenzia"></agenzia-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Compagnia</mat-label>
            <compagnia-picker [multipleSelection]="true" formControlName="compagnia"></compagnia-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Ispettorato</mat-label>
            <ispettorato-picker formControlName="ispettorato"></ispettorato-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Contraente</mat-label>
            <contraente-picker type="contraente" formControlName="contraente"></contraente-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Denominazione Contraente</mat-label>
            <buffered-input formControlName="denominazione_contraente"></buffered-input>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Controparte</mat-label>
            <contraente-picker type="controparte" formControlName="controparte"></contraente-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Amministratore</mat-label>
            <amministratore-picker formControlName="amministratore"></amministratore-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Stato Videoperizia</mat-label>
            <stato-videoperizia-picker formControlName="stato_videoperizia"></stato-videoperizia-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Riparazione in Forma Specifica</mat-label>
            <stato-riparazione-picker formControlName="stato_riparazione"></stato-riparazione-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Comune</mat-label>
            <comune-picker formControlName="comune"></comune-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>CAP</mat-label>
            <buffered-input formControlName="cap"></buffered-input>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Via Incarico</mat-label>
            <buffered-input formControlName="via"></buffered-input>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Provincia</mat-label>
            <provincia-picker formControlName="provincia"></provincia-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Zona Geografica</mat-label>
            <zona-geografica-picker formControlName="zona_geografica"></zona-geografica-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Broker</mat-label>
            <buffered-input formControlName="broker"></buffered-input>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Gruppo Rami</mat-label>
            <gruppo-rami-picker type="number" formControlName="gruppo_rami"></gruppo-rami-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Note</mat-label>
            <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10"
                matInput formControlName="note"></textarea>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Ramo</mat-label>
            <ramo-picker formControlName="ramo"></ramo-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>CGA</mat-label>
            <cga-picker displayField="nome_condizione" formControlName="cga"></cga-picker>
        </mat-form-field>
    </div>
    <div class="row col-12">
        <div class="col-3 text-right">
            <mat-label class="mr-2">Sinistro Over 10.000</mat-label>
            <mat-slide-toggle formControlName="over_10000"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Sinistro Over 50.000</mat-label>
            <mat-slide-toggle formControlName="over_50000"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Globale Fabbricati</mat-label>
            <mat-slide-toggle formControlName="globale_fabbricati"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Riserva</mat-label>
            <mat-slide-toggle formControlName="riserva"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Pronta Liquidazione</mat-label>
            <mat-slide-toggle formControlName="pronta_liquidazione"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Foto Attestati il Danno</mat-label>
            <mat-slide-toggle formControlName="foto_attestati_danno"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Doc. Contabile Opere di Ripristino</mat-label>
            <mat-slide-toggle formControlName="documento_contabile_opere_ripristino"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Sopralluoghi da Effettuare</mat-label>
            <mat-slide-toggle formControlName="sopralluoghi_da_effettuare"></mat-slide-toggle>
        </div>
        <div class="col-3 text-right">
            <mat-label class="mr-2">Sollecitato</mat-label>
            <mat-slide-toggle formControlName="sollecitato"></mat-slide-toggle>
        </div>
    </div>

    <div class="mat-form-field mt-3 mb-1 p-0">
        <button mat-raised-button color="warn" (click)="reset()"
            matTooltip="Resetta tutti i campi della ricerca (il risultato è uguale al refresh della pagina)"> Reset
        </button>
    </div>
</div>